import JikeLogo from '@/assets/jike-logo.svg?react'
import { CONFIRM_SESSION, CREATE_SESSION } from '@/constants/api'
import storage from '@/utils/Storage'
import { getLoginQRCodeURL, refreshTokens } from '@/utils/fetchers/auth'
import { currentUserQueryOptions } from '@/utils/fetchers/user'
import queryClient from '@/utils/queryClient'
import { generalAxiosInstance } from '@/utils/request'
import { Button } from '@mantine/core'
import { useQuery } from '@tanstack/react-query'
import { AnimatePresence, motion } from 'motion/react'
import { QRCodeCanvas } from 'qrcode.react'
import { useMemo, useState } from 'react'
import ScanQRCodeTutorial from '@/components/ScanQRCodeTutorial'
import loginSectionStyles from './LoginSection.module.css'
import styles from './DesktopLoginSection.module.css'

export default function DesktopLoginSection() {
	const [isScanCodeTutorialShow, setIsScanCodeTutorialShow] = useState<boolean>(false)

	const { data: uuid } = useQuery<string>({
		queryKey: [CREATE_SESSION],
		queryFn: async () =>
			await generalAxiosInstance
				.get(CREATE_SESSION)
				.then((res) => res.data.uuid)
				.then((uuid) => {
					if (!uuid) {
						throw new Error('No valid uuid')
					}
					return uuid
				}),
	})
	const loginQRCodeURL = useMemo(() => getLoginQRCodeURL(uuid), [uuid])

	useQuery({
		queryKey: [CONFIRM_SESSION, uuid],
		queryFn: async () =>
			generalAxiosInstance
				.get(CONFIRM_SESSION, {
					params: {
						uuid,
					},
				})
				.then((res) => res.data)
				.then((data) => {
					const refreshToken = data['x-jike-refresh-token']
					const token = data.token

					if (!data.confirmed) {
						throw new Error('Not Confirmed')
					}
					return {
						token,
						refreshToken,
					}
				})
				.then((tokens) => refreshTokens(tokens.refreshToken))
				.then(async (tokens) => {
					storage.auth.token = tokens.token
					storage.auth.refreshToken = tokens.refreshToken

					await queryClient.invalidateQueries({
						queryKey: currentUserQueryOptions.queryKey,
						refetchType: 'all',
					})

					queryClient.setQueryData([CREATE_SESSION], null)
					window.location.reload()
					return tokens
				}),
		enabled: !!uuid,
		retry: !!uuid,
		retryDelay: 1000,
	})

	return (
		<motion.div layout className={loginSectionStyles.card}>
			<motion.div layout className={loginSectionStyles.content}>
				<div className={loginSectionStyles.logoContainer}>
					<JikeLogo className={loginSectionStyles.logo} />

					<div className={styles.qrCodeContainer}>
						{loginQRCodeURL && (
							<div className={styles.qrCodeWrapper}>
								<QRCodeCanvas value={loginQRCodeURL} className={styles.qrCode} />
							</div>
						)}
					</div>

					<div className={styles.text}>
						可使用
						<strong>即刻 App</strong>
						扫码
					</div>
				</div>

				<footer>
					<Button
						variant="transparent"
						c="var(--tint-secondary)"
						size="sm"
						onClick={() => {
							setIsScanCodeTutorialShow((prev) => !prev)
						}}
					>
						如何扫码
					</Button>
				</footer>
			</motion.div>

			<AnimatePresence mode="popLayout">
				{isScanCodeTutorialShow && <ScanQRCodeTutorial layout />}
			</AnimatePresence>
		</motion.div>
	)
}
